import { render } from "./EditMandaturePage.vue?vue&type=template&id=ef71b90a&ts=true"
import script from "./EditMandaturePage.vue?vue&type=script&lang=ts"
export * from "./EditMandaturePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__